import { createScope } from './scope';
import { initReveal } from './reveal';
import { initProductBuilder } from './product-builder';
import { initProductSections } from './product-sections';

/** 기능소개 페이지 인터랙션 시작. 반환값은 정리(cleanup) 함수 */
export function initProduct(root: HTMLElement) {
  const scope = createScope();
  initProductBuilder(root, scope);
  initReveal(root, scope, '.pd-rv');
  initProductSections(root, scope);
  return () => scope.dispose();
}
